import { StyledPrimaryCell, StyledH2 } from '@/components/CrossChainSwaps/utils';
import { MarketingLiquiditySection } from '@/components/MarketingSection/MarketingLiquiditySection';
import { MatchaAutoBenefitsSection } from '@/components/MatchaAuto/MatchaAutoBenefitsSection';

export const SettingUpSection = () => {
  return (
    <StyledPrimaryCell className="flex flex-col items-center mt-5 px-0">
      <StyledH2 className="mx-6 text-center">Setting you up for success</StyledH2>
      <MatchaAutoBenefitsSection
        itemsText={[
          'Save on slippage and cut down opportunity cost.',
          'Maximize success with less than 1% revert rates.',
          'Get unbeatable rates with priority execution.',
        ]}
        fasterOnChainText="Timing is everything. Get privileged access to private mempools and beat the market with fast, efficient execution."
      />

      <div className="w-full">
        <MarketingLiquiditySection bodyText="Get the best prices and the widest choice of tokens by routing through deep liquidity." />
      </div>
    </StyledPrimaryCell>
  );
};
